export default __webpack_public_path__ + "static/media/icon-lists.0da69b43.svg";